/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function SwatchBookIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="swatch-book"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M3.5 5.5C3.5 4.395 4.395 3.5 5.5 3.5L7.5 3.5C8.605 3.5 9.5 4.395 9.5 5.5L9.5 17.5C9.5 19.157 8.157 20.5 6.5 20.5C4.843 20.5 3.5 19.157 3.5 17.5L3.5 5.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M9.5 10.257L12.864 6.893C13.645 6.112 14.911 6.112 15.692 6.893L17.107 8.308C17.888 9.089 17.888 10.355 17.107 11.136L8.621 19.621" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M13.743 14.5L18.5 14.5C19.605 14.5 20.5 15.395 20.5 16.5L20.5 18.5C20.5 19.605 19.605 20.5 18.5 20.5L6.5 20.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M6.5 18L6.5 18" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(133.333)} data-tinysvg-stroke-width="133.333" />
    </svg>
  )
}
